/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Represents a single JSON Patch operation (RFC 6902).
 * Only supports add, remove, and replace operations for config updates.
 * @export
 * @interface JSONPatchOperation
 */
export interface JSONPatchOperation {
    /**
     * The operation to perform.
     * - "add": Adds a new field or replaces an existing one at the specified path
     * - "remove": Removes the field at the specified path
     * - "replace": Replaces the value at the specified path
     * @type {string}
     * @memberof JSONPatchOperation
     */
    op: JSONPatchOperationOpEnum;
    /**
     * JSON Pointer path to the field to operate on (RFC 6901).
     * All paths must start with "/" (e.g., "/schedule", "/selectedFields/phone").
     * @type {string}
     * @memberof JSONPatchOperation
     */
    path: string;
    /**
     * The value to set for add/replace operations.
     * Not used for remove operations.
     * @type {any}
     * @memberof JSONPatchOperation
     */
    value?: any | null;
}


/**
 * @export
 */
export const JSONPatchOperationOpEnum = {
    Add: 'add',
    Remove: 'remove',
    Replace: 'replace'
} as const;
export type JSONPatchOperationOpEnum = typeof JSONPatchOperationOpEnum[keyof typeof JSONPatchOperationOpEnum];


/**
 * Check if a given object implements the JSONPatchOperation interface.
 */
export function instanceOfJSONPatchOperation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "path" in value;

    return isInstance;
}

export function JSONPatchOperationFromJSON(json: any): JSONPatchOperation {
    return JSONPatchOperationFromJSONTyped(json, false);
}

export function JSONPatchOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JSONPatchOperation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'path': json['path'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JSONPatchOperationToJSON(value?: JSONPatchOperation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'path': value.path,
        'value': value.value,
    };
}

